<ng-lottie [styles]="styles" [options]="options" (complete)="complete()"></ng-lottie>
